import React, { useState } from "react";

import AddPurChase from "./AddPurChase";
import DetailPurchase from "./DetailPurchase";
import PurChase from "./PurChase";
import { VoteDateContextProvider } from "contexts/VoteDate";

const Index = props => {
  const SwitchComponents = ({ active, children }) => {
    return children.filter(child => child.props.name === active);
  };
  // Local State
  const [pageProps, setPageProps] = useState({
    active: "PurChase",
    props: null
  });

  return (
    <VoteDateContextProvider>
      {window.scrollTo(0, 0)}
      <SwitchComponents active={pageProps.active}>
        <PurChase
          name="PurChase"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <AddPurChase
          name="AddPurChase"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
        <DetailPurchase
          name="DetailPurchase"
          pageProps={pageProps}
          setPageProps={setPageProps}
        />
      </SwitchComponents>
    </VoteDateContextProvider>
  );
};

export default Index;
